import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { NickNameModalService } from '@app/feature/main/roles-shared/services/nick-name-modal.service';
import { ConnectMiniProfileComponent } from '@app/shared/components/connect-mini-profile/connect-mini-profile.component';
import { CommentService } from '@app/shared/services/comment.service';
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { CommentModalService } from '@app/shared/services/comment-modal.service';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';
declare var $: any;

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css']
})
export class CommentComponent implements OnInit {

  @Input('futureData') public researchData: any;
  @ViewChild(ConnectMiniProfileComponent) connectionMini: ConnectMiniProfileComponent;
  addCommentForm: FormGroup;
  userDetailsObject;
  userId;
  loggedInStatus: boolean = false;
  commentText: string = '';
  nickNameItems: any = [];
  previousText: string = '';
  allUsersList: any = [];
  actualCommentString: string = '';
  constructor(
    public rolesSharedService: RolesSharedService,
    private nickNameModalService: NickNameModalService,
    private formBuilder: FormBuilder,
    private commentService: CommentService,
    private router: Router,
    private breadcrumService: BreadcrumService,
    private commentModalService: CommentModalService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService
  ) { }

  ngOnInit() {

    this.userDetails();
    this.createCommentForm();
    this.getAllUsersList();
    this.populateComments(this.researchData);
  }

  autosizeComment() {
    setTimeout(function () {
      const elm = document.getElementById('comment');
      elm.style.cssText = 'height: auto';
      elm.style.cssText = 'height:' + elm.scrollHeight + 'px';
    }, 0);
  }

  autosizeReply() {
    setTimeout(function () {
      const elm = document.getElementById('reply');
      elm.style.cssText = 'height: auto';
      elm.style.cssText = 'height:' + elm.scrollHeight + 'px';
    }, 0);
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.loggedInStatus = true;
      this.userId = this.userDetailsObject.userId;
    }
  }

  populateComments(post) {
    if (this.userDetailsObject.nickName) {
      this.rolesSharedService
        .getComments(this.commentFilter(post, null, null))
        .subscribe((resp: any) => {
          post.commentsData = resp.data;
          for (let i = 0; i < +post.commentsData["length"]; i++) {
            post.commentsData[i].showComments = false;
            post.commentsData[i].liked = post.commentsData[i].isLiked;
            post.commentsData[i].likes = post.commentsData[i].likeCount;
            post.commentsData[i].replyComments = post.commentsData[i].replyCommentsCount;
            if (!isNaN(post.comments) &&  (+post.commentsData.length) < +post.comments) {
              post.showMoreComments = true;
              post.showLessComments = false;
            } else if(!isNaN(post.commentCount) &&  (+post.commentsData.length) < +post.commentCount) {
              post.showMoreComments = true;
              post.showLessComments = false;
            } else {
              post.showMoreComments = false;
              post.showLessComments = true;
            }
          }
        });
    } else {

      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  commentFilter(post, limit, skip) {
    if (limit == null) {
      limit = 5;
    }
    if (skip == null) {
      skip = 0;
    }
    const getCommentFilter = {
      postId: post.postId ? post.postId : post.id,
      parentCommentId: null,
      limit: limit,
      skip: skip
    };
    return getCommentFilter;
  }

  replyCommentFilter(post, comment, limit, skip) {
    if (limit == null) {
      limit = 5;
    }
    if (skip == null) {
      skip = 0;
    }
    const getReplyCommentFilter = {
      postId: post.postId || post.id,
      parentCommentId: comment.id,
      limit: limit,
      skip: skip
    };
    return getReplyCommentFilter;
  }

  showMoreCommentsFilter(post, postNumber, limit, skip) {
    if (limit == null) {
      limit = 0;
    }
    if (skip == null) {
      skip = 0;
    }
    skip = post.commentsData["length"];
    const getCommentFilter = {
      postId: post.postId || post.id,
      parentCommentId: null,
      limit: limit,
      skip: skip
    };
    return getCommentFilter;
  }

  showMoreReplyCommentsFilter(post, commentData, commentNumber, limit, skip) {
    if (limit == null) {
      limit = 0;
    }
    if (skip == null) {
      skip = 0;
    }
    limit = commentData.replyCommentsData["length"];
    skip = commentData.replyCommentsData["length"];
    const getCommentFilter = {
      postId: post.postId || post.id,
      parentCommentId: commentData.id,
      limit: limit,
      skip: skip
    };
    return getCommentFilter;
  }

  populateReplyComments(post, commentData, commentNumber) {
    commentData.showReplyComments = !commentData.showReplyComments;
    this.addCommentForm.reset();
    if (commentData.showReplyComments) {
      this.rolesSharedService
        .getComments(this.replyCommentFilter(post, commentData, null, null))
        .subscribe((resp: any) => {
          const data = resp.data;
          commentData.replyCommentsData = data;
          commentData.replyCommentsData.forEach((element: any, i: any) => {
            commentData.replyCommentsData[i].showReplyComments = false;
            commentData.replyCommentsData[i].liked = commentData.replyCommentsData[i].isLiked;
            commentData.replyCommentsData[i].likes = commentData.replyCommentsData[i].likeCount;
            if (data.length < commentData.replyComments) {
              commentData.showMoreReplyComments = true;
              commentData.showLessReplyComments = false;
            } else {
              commentData.showMoreReplyComments = false;
              commentData.showLessReplyComments = false;
            }
          });
          if (!data) {
            commentData.showMoreReplyComments = false;
            commentData.showLessReplyComments = true;
          }
        });
    }
  }

  createCommentForm() {
    this.addCommentForm = this.formBuilder.group({
      comment: ["", [Validators.required]]
    });
  }

  addComment(post) {
    if (this.userDetailsObject.nickName) {
      let documentPostType = '';
      if (this.addCommentForm.value.comment  && this.addCommentForm.value.comment.trim().length !== 0 ) {
        if (post.postType) {
          if (post.postType === 'comment' || post.postType === 'like') {
            documentPostType = post.itemType;
          }
          else {
            documentPostType = post.postType;
          }
        } else if (post.type === 'all') {
          documentPostType = 'research_document';
        } else if (post.type === 'upcoming_report') {
          documentPostType = 'upcoming_report';
        } else if (post.research) {
          if (post.research.type === 'all') {
            documentPostType = 'trending_research';
          }
        } else if (post.amount || post.amount === 0) {
          documentPostType = 'report';
        } else {
          documentPostType = 'upcoming_research';
        }
        const commentObject = {
          postId: post.postId || post.id,
          postType: documentPostType,
          message: this.replaceAnotataion(this.addCommentForm.value.comment),
          userId: this.userDetailsObject.id,
          isActive: true
        };

        if (post.researchDocumentId) {
          commentObject['researchDocumentId'] = post.researchDocumentId;
        }

        this.rolesSharedService.addComment(commentObject).subscribe(data => {
          post.comments += 1;
          post.commentCount += 1;
          this.mixpanelEventLoggingService.dispatchEvent("comments", {
            "Tech Domain": this.researchData.domain ? this.researchData.domain.name : '' ,
            "Item Type": documentPostType ? documentPostType : '',
            "Item Name": this.researchData.title ? this.researchData.title : ''
          });
          this.rolesSharedService
            .getComments(this.commentFilter(post, null, null))
            .subscribe((data: any) => {
              const response = data.data;
              for (let k = 0; k < response.length; k++) {
                response[k].liked = response[k].isLiked;
                response[k].likes = response[k].likeCount;
                response[k].replyComments = response[k].replyCommentsCount;
              }
              post.commentsData = response;
              this.addCommentForm.reset();
              this.getAllUsersList();
            });
        });
      }
    } else {
      this.getAllUsersList();
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  addReplyComment(post, comment, postNumber: string) {
    if (this.userDetailsObject.nickName) {
      if (this.addCommentForm.value.comment  && this.addCommentForm.value.comment.trim().length !== 0 ) {
        let documentPostType = '';
        if (this.addCommentForm.value.comment) {
          if (comment.postType) {
            if (comment.postType === 'comment' || comment.postType === 'like') {
              documentPostType = comment.itemType;
            }
            else {
              documentPostType = comment.postType;
            }
          }
          else {
            documentPostType = 'upcoming_research';
          }
        }
        const commentObject = {
          postId: post.postId || post.id,
          parentCommentId: comment.id,
          postType: documentPostType,
          message: this.replaceAnotataion(this.addCommentForm.value.comment),
          userId: this.userDetailsObject.id,
          isActive: true
        };
        this.rolesSharedService.addComment(commentObject).subscribe(data => {
          post.comments += 1;
          post.commentCount += 1;
          this.mixpanelEventLoggingService.dispatchEvent("comments", {
            "Tech Domain": this.researchData.domain ? this.researchData.domain.name : '' ,
            "Item Type": documentPostType ? documentPostType : '',
            "Item Name": this.researchData.title ? this.researchData.title : ''
          });
          const elementPosition = this.researchData.commentsData.map(x => {return x.id }).indexOf(comment.id);
          this.researchData.commentsData[elementPosition].replyComments+= 1;
          this.rolesSharedService
            .getComments(this.replyCommentFilter(post, comment, null, null))
            .subscribe((resp: any) => {
              const response = resp.data;
              for (let k = 0; k < response.length; k++) {
                response[k].liked = response[k].isLiked;
                response[k].likes = response[k].likeCount;
                response[k].replyComments = response[k].replyCommentsCount;
              }
              comment.replyCommentsData = response;
              this.addCommentForm.reset();
            });
        });
      }
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      });
    }
  }

  showMoreComments(post, postNumber) {
    this.rolesSharedService
      .getComments(this.showMoreCommentsFilter(post, postNumber, 5, null))
      .subscribe((resp: any) => {
        const data = resp.data;
        for (let j = 0; j < +data["length"]; j++) {
          post.commentsData.push(data[j]);
        }
        for (let i = 0; i < +post.commentsData["length"]; i++) {
          post.commentsData[i].showComments = false;
          post.commentsData[i].liked = post.commentsData[i].isLiked;
          post.commentsData[i].likes = post.commentsData[i].likeCount;
          post.commentsData[i].replyComments = post.commentsData[i].replyCommentsCount;
          if (!isNaN(post.comments) &&  (+post.commentsData.length) < +post.comments) {
            post.showMoreComments = true;
            post.showLessComments = false;
          } else if(!isNaN(post.commentCount) &&  (+post.commentsData.length) < +post.commentCount) {
            post.showMoreComments = true;
            post.showLessComments = false;
          } else {
            post.showMoreComments = false;
            post.showLessComments = true;
          }
        }
        if (data.length == 0) {
          post.showMoreComments = false;
          post.showLessComments = true;
        }
      });
  }

  showLessComments(post, postNumber) {
    this.populateComments(post);
  }


  showMoreReplyComments(post, commentData, commentNumber) {
    this.rolesSharedService.getComments(
      this.showMoreReplyCommentsFilter(post, commentData, commentNumber, 5, null)).subscribe((resp: any) => {
        const data = resp.data;
        for (let j = 0; j < +data.length; j++) {
          data[j].liked = data[j].isLiked;
          data[j].likes = data[j].likeCount;
          data[j].replyComments = data[j].replyCommentsCount;
          commentData.replyCommentsData.push(data[j]);
        }
        commentData.replyCommentsData.forEach((element: any, i: any) => {
          commentData.replyCommentsData[i].showReplyComments = false;

          if (commentData.replyCommentsData.length < commentData.replyComments) {
            commentData.showMoreReplyComments = true;
            commentData.showLessReplyComments = false;
          } else {
            commentData.showMoreReplyComments = false;
            commentData.showLessReplyComments = true;
          }
        });
        if (!data) {
          commentData.showMoreReplyComments = false;
          commentData.showLessReplyComments = true;
        }
      });
  }

  showLessReplyComments(post, commentData, commentNumber) {
    this.populateReplyComments(post, commentData, commentNumber);
  }

  likeClick(postData, postNumber: string) {
    if (this.userDetailsObject.nickName) {
      const likeObject = {
        postId: postData.id,
        postType: "comment",
        userId: this.userDetailsObject.id
      };

      this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
        if (likeResponse["liked"]) {
          // case when user is liked and updated in server
          postData.liked = true;
          postData.likes += 1;
        } else if (!likeResponse["liked"]) {
          // case when user is not liked and updated in server
          postData.liked = false;
          if (postData.likes != 0) {
            postData.likes -= 1;
          }
        }
      })
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }
  showConnectionMiniModal(userId) {
    this.connectionMini.getProfileData(userId);
  }
  mentionSearch(event) {
    this.getMentionedUsersList(event);
  }
  getMentionedUsersList(value) {
    const searchValue = `%${value}%`;
    let mentionFilter = { "where": { "and": [{ "or": [{ "firstName": { "ilike": searchValue } }, { "lastName": { "ilike": searchValue } }, { "nickName": { "ilike": searchValue } }] }, { "nickName": { "neq": null } }] } };
    this.commentService.getNickNameList(mentionFilter).subscribe(
      (resp: any) => {
        this.nickNameItems = resp;

      },
      error => {

      }
    )
  }
  getAllUsersList() {
    this.commentService.getUsersWithNickName().subscribe(
      (resp: any) => {
        this.nickNameItems = resp;
        this.allUsersList = resp;
      },
      error => {

      }
    )
  }
  generateCommentTest(event) {
    if (event === '') {
      this.previousText = '';
    }
    else {

    }
    this.previousText = event;
  }
  replaceAnotataion(commentMsg) {

    let newMessage = '';
    this.allUsersList.forEach((mentionsObj: any) => {
      const exp = `@${mentionsObj.nickName}`;
      const mentionExp = `@${mentionsObj.id}`;
      commentMsg = commentMsg.replace(new RegExp(exp, 'g'), mentionExp);
    });
    return commentMsg;
  }
  format(item: any) {
    return '@' + item['nickName'] + ' ';
  }

  routeTechAnalystProfilePageSide(user, analystId) {
    const name = user.firstName + ' ' + user.lastName;
    this.breadcrumService.setUrl('BC3Label', name);
    this.commentModalService.modalStatus(false, null);
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } });
  }

  scrollDown() {

    $( document ).ready(function() {
      const elm = document.querySelectorAll('#comments-list');
      if (elm.length > 0) {
        const last = elm[elm.length - 1];
        last.scrollIntoView({
          behavior: 'smooth',
          block: "end"
        });
      }
    });

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/components/comment/comment.component.ts